import axios from 'axios'
import environment from '@/settings/environment'

const headers = {
  'Content-Type': 'application/json',
  'x-api-key': environment.pci.key,
}

const apiPCI = axios.create({
  baseURL: environment.pci.url,
  timeout: 30000,
  headers,
});

export default apiPCI;
